import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Disclaimer from "./Disclaimer";
import Wordmark from "./Wordmark";
import { useAuth } from "../context/AuthContext";

// Navbar for signed-in users, a light public header for visitors.
export default function PublicShell({ children, testid }) {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-[var(--bg-base)]">
      {user ? <Navbar /> : (
        <header className="sticky top-0 z-50 w-full border-b border-[var(--border-subtle)] bg-[var(--bg-surface)]">
          <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-3 sm:px-8">
            <Link to="/" data-testid="public-brand-logo"><Wordmark sizeClass="text-2xl sm:text-3xl" /></Link>
            <div className="flex items-center gap-4 text-sm text-[var(--text-secondary)]">
              <Link to="/login" className="hover:text-[var(--text-primary)]" data-testid="public-signin-link">Sign in</Link>
              <Link to="/register" className="hover:text-[var(--text-primary)]" data-testid="public-register-link">Create account</Link>
            </div>
          </div>
        </header>
      )}
      <main className="mx-auto max-w-6xl px-4 pb-20 pt-8 sm:px-8" data-testid={testid}>{children}</main>
      <Disclaimer />
    </div>
  );
}
